import * as React from "react"
import { Skeleton } from "@mui/material"

import { KpiTable } from "@components";
import { useSkuDetailsKeywordsData } from "./@hooks"
import SkuDetailsKeywordTableActions from "./Actions"


export default function SkuDetailsKeywordsTable() {
    const { data, keywords, aggregation, optionSelected, handleChangeOption, isLoadingKeywords } = useSkuDetailsKeywordsData()

    if (isLoadingKeywords) return <Skeleton variant="rectangular" height={500} />
    if (!keywords?.length) return <></>

    return <KpiTable
        data={data}
        aggregations={aggregation}
        title={'Share Of Search Kpis'}
        kpis={keywords.map(keyword => ({
            name: keyword,
            label: keyword
        }))}
        options={{
			tableBodyHeight: '365px',
			customToolbar: () => <SkuDetailsKeywordTableActions optionSelected={optionSelected} handleChangeOption={handleChangeOption} />
		}}
    />
}		